var app = angular.module("leonardo");

var DeleteRoleDialog = function($scope, ngDialog, $rootScope, FormErrorsService, AccountUserRoleService,
                                NotificationService, AccountUserService, FolderService, AuthDataService, $q, $filter) {

  $scope.role = $scope.ngDialogData.role;
  $scope.roles = [];
  $scope.accountUsers = [];
  $scope.documentFolders = [];

  $scope.removeRole = function() {
    var roles = [];
    angular.forEach($scope.roles, function (role) {
      if (role.id != $scope.role.id) {
        roles.push(role);
      }
    });
    $scope.roles = roles;
  };

  if (!isNull($scope.role.account)) {

    AccountUserService.getlist({disable_pagination:true, essential:true, role: $scope.role.id}).then(function (data) {
      $scope.accountUsers = data.results ? data.results : data;
    });
    FolderService.getlist({disable_pagination:true, summary:true, role: $scope.role.id}).then(function (data) {
      $scope.documentFolders = data.results ? data.results : data;
    });

    // if (AccountUserRoleService.getCollection().length > 0) {
    //   $scope.roles = AccountUserRoleService.getCollection();
    // }
    // else {
      $scope.roles = AccountUserRoleService.getAll({summary:true, system:(AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()),account: AccountUserService.currentAccountUser.account});
    // }
  }

  $q.when($scope.roles).then(function (data) {
    var results = data.results ? data.results : data;
    $scope.roles = $filter('orderBy')(results, 'name');
    $scope.removeRole();
  });

  function triggerDialogCallback(){
    $scope.role.remove().then(function() {
      AccountUserRoleService.updateCollection($scope.role, true);
      AccountUserService.updateVisibleRoles($scope.role, true);
      $rootScope.$broadcast('account-user-roles:updated');
      $scope.closeThisDialog();
    });
  }

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if ($scope.new_role_for_account_users || $scope.new_role_for_documents)
      $scope.role.preDelete({
        new_role_for_account_users: parseInt($scope.new_role_for_account_users),
        new_role_for_documents: parseInt($scope.new_role_for_documents)
      }).then(function() {
        triggerDialogCallback();
      });
    else {
      triggerDialogCallback();
    }
  };
};

app.controller('DeleteRoleDialog', ['$scope', 'ngDialog', '$rootScope', 'FormErrorsService', 'AccountUserRoleService',
  'NotificationService', 'AccountUserService', 'FolderService', 'AuthDataService', '$q', '$filter', DeleteRoleDialog]);
